import { api } from '@/global/api'
import { GetFilterResponse } from '@/modules/accredited-establishments/api/types'

export const getSpecialtiesFilterOptions =
  async (): Promise<GetFilterResponse> => {
    const { data } = await api.get<GetFilterResponse>(
      `/site_accredited_network/filters/specialties`
    )
    return data
  }
